const DEFAULT_API_BASE = "https://mwy-construction-hse-api.wqsyns.workers.dev";

export const API_BASE =
  (process.env.REACT_APP_BACKEND_URL || DEFAULT_API_BASE).replace(/\/$/, "");

export async function apiGet(path) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

  if (!res.ok) {
    throw new Error(`API GET failed: ${res.status}`);
  }

  const json = await res.json();
  if (json && json.ok === false) {
    throw new Error(json.message || "API request failed");
  }

  return json.data ?? json;
}

export async function apiPost(path, payload) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    throw new Error(`API POST failed: ${res.status}`);
  }

  const json = await res.json();
  if (json && json.ok === false) {
    throw new Error(json.message || "API request failed");
  }

  return json.data ?? json;
}
